import { action, makeObservable, observable } from 'mobx';
import UserStore from './UserStore';
import _ from 'lodash';

class MainStore {
  currentPanelView = 'main';

  constructor() {
    makeObservable(this, {
      currentPanelView: observable,
      GetAllRelateStore: action,
      SetCurrentPanelView: action,
    });
  }

  async GetAllRelateStore() {
    const _request = [];

    _request.push(
      UserStore.GetUser(_.get(UserStore, 'accessAuthen.auth_id', ''))
        .then((resp) => {
          return Promise.resolve(resp);
        })
        .catch((errs) => {
          return Promise.reject(errs);
        })
    );

    await Promise.all(_request)
      .then((resp) => {
        return Promise.resolve(resp);
      })
      .catch((errs) => {
        const { description = '' } = errs;
        return Promise.reject(description);
      });
  }

  SetCurrentPanelView(payload) {
    this.currentPanelView = payload;
  }

  async CheckRefreshToken() {
    const expiresAt = UserStore.accessAuthen?.expires_at || 0;

    const currentDate = new Date();
    const toMiliTime = currentDate.getTime();

    if (toMiliTime > expiresAt) {
      UserStore.RefreshToken();
      // UserStore.RefreshQueueToken();
    }
  }
}

const CoreStore = new MainStore();
export default CoreStore;
